import { ReactNode } from 'react'
import styled from 'styled-components'

export interface TableColumnType<T> {
  id: string
  label: ReactNode
  dataIndex: string
  render?: (data: T) => ReactNode
}

interface PredictionTableHeadProps<T> {
  tableColumns: TableColumnType<T>[]
}

const PredictionTableHead = <T extends object>({
  tableColumns,
}: PredictionTableHeadProps<T>) => {
  return (
    <StyledWrapper>
      <tr>
        {tableColumns.map((column) => {
          return <th key={column.id}>{column.label}</th>
        })}
      </tr>
    </StyledWrapper>
  )
}

export default PredictionTableHead

const StyledWrapper = styled.thead`
  > tr {
    &:first-child {
      border-left: none;
    }
    &:last-child {
      border-right: none;
    }

    > th {
      border-collapse: collapse;
      border: 1px solid #eeeeee;
      background-color: #fafafa;
      text-align: center;
      padding: 14px 0px;
      font-size: 16px;
      font-weight: 500;
      letter-spacing: -0.64px;
      color: #333;
    }
  }
`
